import { render, staticRenderFns } from "./mbinfo.vue?vue&type=template&id=26df081b&scoped=true&"
import script from "./mbinfo.vue?vue&type=script&lang=js&"
export * from "./mbinfo.vue?vue&type=script&lang=js&"
import style0 from "./mbinfo.vue?vue&type=style&index=0&id=26df081b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26df081b",
  null
  
)

export default component.exports